// /*!
// * Copyright © 2025 FBSPL. All rights reserved.
// * This script is proprietary and confidential.
// * Unauthorized copying, distribution, or modification is strictly prohibited.
// */
import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-vimeo-player',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vimeo-player.component.html',
  styleUrl: './vimeo-player.component.css',
})
export class VimeoPlayerComponent {
  @Input() useWhitePlayButton: boolean = false;
  @Input() videoUrl!: string;
  @Input() thumbnail!: string;
  @Input() alt!: string;

  @ViewChild('videoPlayer', { static: false })
  videoPlayer!: ElementRef<HTMLIFrameElement>;

  public safeVideoUrl?: SafeResourceUrl;
  public showOverlay: boolean = true;
  cdnThumbnail?: string;
  cdnUrl = environment.cdnUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.showOverlay = true;
    if (this.thumbnail) {
      this.cdnThumbnail = `${this.cdnUrl}${this.thumbnail}`;
    }
  }

  playVideo(): void {
    this.showOverlay = false;
    const urlWithParams = `${this.videoUrl}?autoplay=1&badge=0&autopause=1&title=0&byline=0&portrait=0&player_id=0&app_id=58479`;
    this.safeVideoUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(urlWithParams);
  }
}
